import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

import { group } from '@angular/animations';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { join } from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-advance-filter',
  templateUrl: './advance-filter.component.html',
  styleUrls: ['./advance-filter.component.scss']
})
export class AdvanceFilterComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';


  newData: any;

  text: any;

  firstFormGroup: UntypedFormGroup;

  _form: UntypedFormGroup;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    public snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<AdvanceFilterComponent>, private router: Router

  ) {

    this.newData = data;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  ngOnInit() {

    this.text = "Search";

    this.init = false;
    this._createFormNew();

    const savedData = localStorage.getItem('advanceFilterConditions');
    if (savedData) {

      this.loadFormData(savedData);


    }





    this.init = true;


  }





  type: any = [
    { "value": 0, "viewValue": "Lead" },
    { "value": 1, "viewValue": "Activity" },
  ];

  init: boolean = false;

  onSelectionChange(event: MatSelectChange): void {
    const type = event.value;
    this.init = true;

  }

  close() {
    this.dialogRef.close({ event: 'close' })
  }

  submit() {
    console.log(this._form);


    if(this._form.value.data.length==1){

      let value =this._form.value.data[0].value;

      if(value.length==1){

        let statement =value[0].statement;

       console.log(statement);

       if(statement.groups.length==1){
        let groups =statement.groups[0];

        console.log(groups);

        if(groups.groups==0 && groups.conditions==0){

          this.snackBar.open("Please Set Atleast One Condition", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
       
          return;
        }
       }
       
      }


    }

if(this._form.valid){

  let activityQuery = null;

  let leadQuery = null;

  this._form.value.data.forEach(data => {

    let finalResult: any = "";
    
    data.value.forEach(value => {

      if (data.type == 0) {

        finalResult = this.constructRule(value);

        if (finalResult.length > 0) {

          if (leadQuery == null) {

            leadQuery = finalResult;
          } else {
            leadQuery += " AND " + finalResult;
          }

        }

      } else {
        finalResult = this.constructRuleActivity(value);

        if (finalResult.length > 0) {

          if (activityQuery == null) {

            activityQuery = finalResult;
          } else {
            activityQuery += " AND " + finalResult;
          }

        }
      }

    });

  });

  let object = {
    activity: activityQuery,
    lead: leadQuery
  };
  localStorage.setItem('advanceFilterConditions', JSON.stringify({
    type: this._form.value,
      
  }));

  localStorage.setItem('advanceFilterConditionsText', JSON.stringify({
    condition: object,
      
  }));


  this.dialogRef.close({
    event: 'submit',
    conditions: object
  });


}else{

  this._form.markAllAsTouched();
}




  }

  deleteDataBlock(index: number) {
    if (index === 0) {
      return;
    }
    const dataArray = this._form.get('data') as FormArray;
    dataArray.removeAt(index);
  }



  constructRule(inputJson: any) {
    inputJson = inputJson.statement;
    inputJson = inputJson.groups[0];
    return this.constructRuleStmt(inputJson, '', false, '');
  }

  constructRuleActivity(inputJson: any) {
    inputJson = inputJson.statement;
    inputJson = inputJson.groups[0];
    return this.constructRuleStmtActivity(inputJson, '', false, '');
  }

  private constructRuleStmtActivity(inputJson: any, ruleStmt: string, isGroupNestedGroup: boolean, conjunctor: string) {
    if (conjunctor === 'AND') {
      conjunctor = 'and';
    }
    if (conjunctor === 'OR') {
      conjunctor = 'OR';
    }

    if (conjunctor === 'BETWEEN') {
      conjunctor = 'between';
    }

    if (isGroupNestedGroup) {
      ruleStmt = ruleStmt + ' ' + conjunctor + ' ';
      ruleStmt = ruleStmt + ' ( ';
    }

    if (inputJson.hasOwnProperty('conditions')) {
      const jsonArray = (inputJson.conditions as Array<any>);
      for (let i = 0; i < jsonArray.length; i++) {
        const jsonObject = jsonArray[i] as object;

        if (jsonObject['operators'] == '==') {


          if (typeof jsonObject['fieldValue'] === 'object' 
          && Array.isArray(jsonObject['fieldValue'])) {

            let val: any = this.getNestedConditionsSql(jsonObject['fieldValue']);

            if (val !== undefined && val !== null && val !== '' && val.includes("IN (")) {
              // If val is a number, append it to ruleStmt
              ruleStmt = ruleStmt + 'a.' + jsonObject['fieldName'] + ' ' + val;
            } else {
              ruleStmt = ruleStmt + "LOWER(" + "a." + jsonObject['fieldName'] + ')=' + "'" + jsonObject['fieldValue'] + "'";
            }

          } else {
            if (!isNaN(jsonObject['fieldValue'])) {
              ruleStmt = ruleStmt + "LOWER(" + "a." + jsonObject['fieldName'] + ')=' + jsonObject['fieldValue'];
            } else {
              ruleStmt = ruleStmt + "LOWER(" + "a." + jsonObject['fieldName'] + ')=' + "'" + jsonObject['fieldValue'].toLowerCase() + "'";
            }

          }
        }
        else if (jsonObject['operators'] == '!=') {
          ruleStmt = ruleStmt + 'a.' + jsonObject['fieldName'] + '!=' + "'" + jsonObject['fieldValue'] + "'";
        }
        else if (jsonObject['operators'] == 'contains'
        ) {

          if (!isNaN(jsonObject['fieldValue'])) {
            ruleStmt = ruleStmt + 'a.' + jsonObject['fieldName'] + jsonObject['fieldValue'];
          } else {
            ruleStmt = ruleStmt + "LOWER(" + "a." + jsonObject['fieldName'] + ") LIKE '%" + jsonObject['fieldValue'].toLowerCase() + "%'";
          }

        }
        else if (jsonObject['operators'] == '>=') {
          ruleStmt = ruleStmt + jsonObject['fieldName'] + jsonObject['operators'] + parseFloat(jsonObject['fieldValue']);
        } else if (jsonObject['operators'] == '<=') {
          ruleStmt = ruleStmt + +"a." + jsonObject['fieldName'] + jsonObject['operators'] + parseFloat(jsonObject['fieldValue']);
        } else if (jsonObject['operators'] == '>') {
          ruleStmt = ruleStmt + "a." + jsonObject['fieldName'] + jsonObject['operators'] + parseFloat(jsonObject['fieldValue']);
        }if (jsonObject['operators'] === '<') {
          ruleStmt += `a.${jsonObject['fieldName']} IS NOT NULL AND a.${jsonObject['fieldName']} < ${parseFloat(jsonObject['fieldValue'])} `;
      }else if (jsonObject['operators'] === 'BETWEEN') {
          const value = jsonObject['fieldValue'];
          if (typeof value === 'string' && value.includes('~')) {
            let [min, max] = value.split('~').map((v: string) => v.trim());
        
            // Append start of day time to min
            if (!min.includes(' ')) {
              min = `${min} 00:00:00`;
            }
        
            // Append end of day time to max
            if (!max.includes(' ')) {
              max = `${max} 23:59:59`;
            }
        
            ruleStmt += ` a.${jsonObject['fieldName']} BETWEEN '${min}' AND '${max}' `;
          }
        }
        
        else if (jsonObject['operators'] === 'NOT BETWEEN') {
          const value = jsonObject['fieldValue'];
          if (typeof value === 'string' && value.includes('~')) {
            let [min, max] = value.split('~').map((v: string) => v.trim());
        
            // Append start of day time to min
            if (!min.includes(' ')) {
              min = `${min} 00:00:00`;
            }
        
            // Append end of day time to max
            if (!max.includes(' ')) {
              max = `${max} 23:59:59`;
            }
        
            ruleStmt += ` a.${jsonObject['fieldName']} NOT BETWEEN '${min}' AND '${max}' `;
          }
        }
    
        if (i !== jsonArray.length - 1) {
          let conjunctorTemp = inputJson.conjunctor;
          if (conjunctorTemp === 'AND') {
            conjunctorTemp = ' AND ';
          }
          if (conjunctorTemp === 'OR') {
            conjunctorTemp = ' OR ';
          }
          ruleStmt = ruleStmt + ' ' + conjunctorTemp + ' ';
        }
      }
    }
    if (inputJson.hasOwnProperty('groups')) {
      const jsonArray = (inputJson.groups as Array<any>);
      for (let i = 0; i < jsonArray.length; i++) {

        const jsonObject = jsonArray[i] as object;

        if(jsonObject['conditions'].length>0 &&jsonObject['groups'].length>0){
      
          ruleStmt = this.constructRuleStmt(jsonObject, ruleStmt, true, inputJson.conjunctor);
          ruleStmt = ruleStmt + ' ) ';
        }
      
      }
    }
    return ruleStmt;
  }

  private constructRuleStmt(inputJson: any, ruleStmt: string, isGroupNestedGroup: boolean, conjunctor: string) {
   
  
    if (conjunctor === 'AND') {
      conjunctor = 'and';
    }
    if (conjunctor === 'OR') {
      conjunctor = 'OR';
    }
    if (isGroupNestedGroup) {
      ruleStmt = ruleStmt + ' ' + conjunctor + ' ';
      ruleStmt = ruleStmt + ' ( ';
    }

    if (inputJson.hasOwnProperty('conditions')) {
      const jsonArray = (inputJson.conditions as Array<any>);
      for (let i = 0; i < jsonArray.length; i++) {
        const jsonObject = jsonArray[i] as object;

        if (jsonObject['operators'] == '==') {


          if (typeof jsonObject['fieldValue'] === 'object' && Array.isArray(jsonObject['fieldValue'])) {

            let val = this.getNestedConditions(jsonObject['fieldValue']);

            ruleStmt = ruleStmt + jsonObject['fieldName'] + ':' + val ;
          } else {
            ruleStmt = ruleStmt + jsonObject['fieldName'] + ':' +
             jsonObject['fieldValue'].replace(/(?<=\S) (\S)/g, '?$1'); ;
          }
        }
        else if (jsonObject['operators'] == '!=') {

          
          if (typeof jsonObject['fieldValue'] === 'object' && Array.isArray(jsonObject['fieldValue'])) {

            let val = this.getNestedConditions(jsonObject['fieldValue']);

            ruleStmt = ruleStmt + '!' + jsonObject['fieldName'] + ':' + val ;
          } else {
            ruleStmt = ruleStmt + '!' + jsonObject['fieldName'] + ':' + jsonObject['fieldValue'].replace(/(?<=\S) (\S)/g, '?$1');;
          }
          
        }
        else if (jsonObject['operators'] == 'contains') {
          let value = jsonObject['fieldValue'];
        
          if (typeof value !== 'string') {
            // convert to string if not string (for example, if array, join with space)
            if (Array.isArray(value)) {
              value = value.join(' ');
            } else {
              value = String(value);
            }
          }
        
          ruleStmt = ruleStmt + jsonObject['fieldName'] + ':*' + value.replace(/(?<=\S) (\S)/g, '?$1') + '*';
        }
        else if (jsonObject['operators'] == 'endsWith') {

          ruleStmt = ruleStmt + jsonObject['fieldName'] + ':*' + jsonObject['fieldValue'].replace(/(?<=\S) (\S)/g, '?$1');
          
          }
          
          else if (jsonObject['operators'] == 'startsWith') {
          
          ruleStmt = ruleStmt + jsonObject['fieldName'] + ':' + jsonObject['fieldValue'].replace(/(?<=\S) (\S)/g, '?$1') + '*';
          
          }
        else if (jsonObject['operators'] === '<=') {
          ruleStmt += `${jsonObject['fieldName']}:[* TO ${parseFloat(jsonObject['fieldValue'].replace(/\s/g, ''))}]`;
        }else if (jsonObject['operators'] === '>') {
          ruleStmt += `${jsonObject['fieldName']}:{${
            parseFloat(jsonObject['fieldValue'].replace(/\s/g, ''))
          } TO *}`;
        } else if (jsonObject['operators'] === '>=') {
          ruleStmt += `${jsonObject['fieldName']}:[${ 
            parseFloat(jsonObject['fieldValue'].replace(/\s/g, ''))
          } TO *]`;
        } else if (jsonObject['operators'] === '<') {
          ruleStmt += `${jsonObject['fieldName']}:{* TO ${parseFloat(jsonObject['fieldValue'].replace(/\s/g, ''))}}`;
        }

        else if (jsonObject['operators'] === 'BETWEEN') {
          const value = jsonObject['fieldValue'];
          if (typeof value === 'string' && value.includes('~')) {
            const [min, max] = value.split('~').map((v: string) => v.trim());
        
            // Shift min date one day back and add 19:20:05
            const minDate = new Date(min);
            minDate.setDate(minDate.getDate() - 1);
            minDate.setUTCHours(19, 20, 5, 0);
            const formattedMin = minDate.toISOString().split('.')[0] + 'Z';
        
            // Keep max date as-is but add 18:29:59
            const maxDate = new Date(max);
            maxDate.setUTCHours(18, 29, 59, 0);
            const formattedMax = maxDate.toISOString().split('.')[0] + 'Z';
        
            ruleStmt += `(${jsonObject['fieldName']}:[${formattedMin} TO ${formattedMax}])`;
          }
        }

        else if (jsonObject['operators'] === 'NOT BETWEEN') {
          const value = jsonObject['fieldValue'];
          if (typeof value === 'string' && value.includes('~')) {
            const [min, max] = value.split('~').map((v: string) => v.trim());
        
            // Shift min date one day back and set time to 19:20:05
            const minDate = new Date(min);
            minDate.setDate(minDate.getDate() - 1);
            minDate.setUTCHours(19, 20, 5, 0);
            const formattedMin = minDate.toISOString().split('.')[0] + 'Z';
        
            // Set max date time to 18:29:59
            const maxDate = new Date(max);
            maxDate.setUTCHours(18, 29, 59, 0);
            const formattedMax = maxDate.toISOString().split('.')[0] + 'Z';
        
            // Final Solr query clause with NOT BETWEEN and NOT NULL
              ruleStmt += `!(${jsonObject['fieldName']}:[${formattedMin} TO ${formattedMax}])`;
          }
        }

        if (i !== jsonArray.length - 1) {
          let conjunctorTemp = inputJson.conjunctor;
          if (conjunctorTemp === 'AND') {
            conjunctorTemp = 'and';
          }
          if (conjunctorTemp === 'OR') {
            conjunctorTemp = 'OR';
          }
          ruleStmt = ruleStmt + ' ' + conjunctorTemp + ' ';
        }
      }
    }
    if (inputJson.hasOwnProperty('groups')) {
      const jsonArray = (inputJson.groups as Array<any>);
      for (let i = 0; i < jsonArray.length; i++) {
        
        const jsonObject = jsonArray[i] as object;
        if(jsonObject['conditions'].length>0 &&jsonObject['groups'].length>0){
        ruleStmt = this.constructRuleStmt(jsonObject, ruleStmt, true, inputJson.conjunctor);
        ruleStmt += ruleStmt + ' ) ';
        }
      }
    }
    return ruleStmt;
  }

  getNestedConditions(salesManagerList: string[]): string {
    let specs = "";
    let i = 0;
    const length = salesManagerList.length - 1;

    if (length > 0) {
      specs += "(";

      for (const name of salesManagerList) {
        if (i === 0) {
          specs += name.toLowerCase().replace(/(?<=\S) (\S)/g, '?$1');;
        } else if (i === length) {
          specs += " OR " + name.toLowerCase().replace(/(?<=\S) (\S)/g, '?$1'); + ")";
        } else {
          specs += " OR " + name.toLowerCase().replace(/(?<=\S) (\S)/g, '?$1');;
        }
        i++;
      }
      specs += ")";
    } else {
      specs += salesManagerList[0].replace(/(?<=\S) (\S)/g, '?$1');;
    }
    return specs;
  }


  getNestedConditionsSql(salesManagerList: string[]): string {
    let specs = "";
    let i = 0;
    const length = salesManagerList.length - 1;

    if (length > 0) {
      specs += "IN (";

      for (let i = 0; i < salesManagerList.length; i++) {
        const name = salesManagerList[i];
        specs += `'${name}'`;       // append name with quotes
        if (i !== salesManagerList.length - 1) {
          specs += ", ";            // append comma + space after all but last
        }
      }
      specs += ")";
    } else {
      specs += salesManagerList[0];
    }
    return specs;
  }

  private _createFormNew() {
    this._form = this._formBuilder.group({
      data: this._formBuilder.array([
        this._formBuilder.group({
          type: [1],
          value: this._formBuilder.array([
            this.createValueItem()
          ])
        })
      ])
    });
    this.init = true;
  }

  private createValueItem(): FormGroup {
    return this._formBuilder.group({
      statement: this._formBuilder.group({
        groups: this._formBuilder.array([
          this.createGroup()
        ])
      })
    });
  }


  get valueFormArray(): FormArray {
    return this._form.get('value') as FormArray;
  }
  _delete1(dataIndex: number, valueIndex: number, groupIndex: number) {
    // Get the 'groups' FormArray at the specified indexes
    const groupsArray = (this._form.get('data') as FormArray)
      .at(dataIndex)
      .get('value') as FormArray;

    const statementGroup = groupsArray.at(valueIndex).get('statement') as FormGroup;

    const groupsFormArray = statementGroup.get('groups') as FormArray;

    // Remove the group at groupIndex
    groupsFormArray.removeAt(groupIndex);
  }
  getGroupsFormArray1(dataIndex: number, valueIndex: number): FormArray {
    return this.getValueFormArray(dataIndex).at(valueIndex)
      .get('statement.groups') as FormArray;
  }
  private createGroup(): FormGroup {
    const group = this._formBuilder.group({
      conjunctor: ['AND'],
      conditions: this._formBuilder.array([]),
      groups: this._formBuilder.array([])
    });

    // Push a condition into this group's conditions array
    // const conditionsArray = group.get('conditions') as FormArray;
    // conditionsArray.push(this.createCondition());

    return group;
  }

  private createCondition(): FormGroup {
    return this._formBuilder.group({
      fieldName: [null, [Validators.required]],
        operators: [null, [Validators.required]],
        fieldValue: [null, [Validators.required]],
      startDate: null,
      endDate: null
    });
  }
  get dataFormArray(): FormArray {
    return this._form.get('data') as FormArray;
  }

  getValueFormArray(dataIndex: number): FormArray {
    return this.dataFormArray.at(dataIndex).get('value') as FormArray;
  }

  addNewData() {
    const dataArray = this._form.get('data') as FormArray;
    dataArray.push(
      this._formBuilder.group({
        type: [1],
        value: this._formBuilder.array([
          this.createValueItem()
        ])
      })
    );
  }

  loadFormData(savedData1: any) {


    let savedData = JSON.parse(savedData1);
    const dataArray = this._form.get('data') as FormArray;
    dataArray.clear();
    savedData.type.data.forEach((dataItem: any) => {
      // Create data item
      const newDataGroup = this._formBuilder.group({
        type: [dataItem.type],
        value: this._formBuilder.array([])
      });

      // Get value FormArray inside this data item
      const valueArray = newDataGroup.get('value') as FormArray;
      valueArray.clear();

      // For each value item in saved data
      dataItem.value.forEach((valueItem: any) => {
        // Create value item group with statement.groups array
        const newValueGroup = this._formBuilder.group({
          statement: this._formBuilder.group({
            groups: this._formBuilder.array([])
          })
        });

        const groupsArray = newValueGroup.get('statement.groups') as FormArray || newValueGroup.get('statement').get('groups') as FormArray;
        groupsArray.clear();

        valueItem.statement.groups.forEach((groupItem: any) => {
          // Create group FormGroup
          const newGroup = this._formBuilder.group({
            conjunctor: [groupItem.conjunctor],
            conditions: this._formBuilder.array([]),
            groups: this._formBuilder.array([])
          });

          // Populate conditions
          const conditionsArray = newGroup.get('conditions') as FormArray;
          groupItem.conditions.forEach((cond: any) => {
            conditionsArray.push(this._formBuilder.group({
              fieldName: [cond.fieldName],
              operators: [cond.operators],
              fieldValue: [cond.fieldValue],
              startDate: [cond.startDate],
              endDate: [cond.endDate],

            }));
          });

          // Populate nested groups if needed (optional)
          // For now, clear groups as empty
          // const nestedGroupsArray = newGroup.get('groups') as FormArray;

          // groupItem.groups.forEach((cond: any) => {

          //   let nestedConditionsArray = this._formBuilder.array([]);
          //   cond.conditions?.forEach((condition: any) => {
          //     nestedConditionsArray.push(this._formBuilder.group({
          //       fieldName: [condition.fieldName],
          //       operators: [condition.operators],
          //       fieldValue: [condition.fieldValue],
          //       startDate: [condition.startDate],
          //       endDate: [condition.endDate]
          //     }));
          //   });

          //   let nestedgroupArray = this._formBuilder.array([]);
          //   cond.groups?.forEach((condition: any) => {
          //     nestedgroupArray.push(this._formBuilder.group({
          //       conjunctor: [condition.conjunctor],
          //   conditions: this._formBuilder.array([]),
          //   groups: this._formBuilder.array([])
          //     }));
          //   });

          //   nestedGroupsArray.push(this._formBuilder.group({


          //     conjunctor: [cond.conjunctor],
          //     conditions:nestedConditionsArray,
          //   groups: nestedgroupArray

          //   }));


          // });

          const nestedGroupsArray = newGroup.get('groups') as FormArray;

          groupItem.groups?.forEach((nestedGroupData: any) => {
            const nestedGroup = this.createGroupFromData(nestedGroupData);
            nestedGroupsArray.push(nestedGroup);
          });


          // Optionally populate nestedGroupsArray here similarly if data exists

          groupsArray.push(newGroup);
        });

        valueArray.push(newValueGroup);
      });

      dataArray.push(newDataGroup);
    });
  }

  private createGroupFromData(groupData: any): FormGroup {
    const conditionsArray = this._formBuilder.array([]);
    groupData.conditions?.forEach((condition: any) => {
      conditionsArray.push(this._formBuilder.group({
        fieldName: [condition.fieldName],
        operators: [condition.operators],
        fieldValue: [condition.fieldValue],
        startDate: [condition.startDate],
        endDate: [condition.endDate]
      }));
    });

    const groupsArray = this._formBuilder.array([]);
    groupData.groups?.forEach((nestedGroup: any) => {
      groupsArray.push(this.createGroupFromData(nestedGroup)); // Recursive call
    });

    return this._formBuilder.group({
      conjunctor: [groupData.conjunctor],
      conditions: conditionsArray,
      groups: groupsArray
    });
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
